import type { Erinnerung, Termin, TerminKurz } from './api'

/** "Sa., 3. Okt." bzw. mit Jahr, wenn es nicht das aktuelle ist; mit Uhrzeit "Sa., 3. Okt. · 19:30" */
export function terminZeit(t: Pick<TerminKurz, 'datum' | 'uhrzeit'>, heute = new Date()): string {
  const d = new Date(`${t.datum}T12:00:00Z`)
  const datum = new Intl.DateTimeFormat('de-DE', {
    timeZone: 'UTC',
    weekday: 'short',
    day: 'numeric',
    month: 'short',
    ...(d.getUTCFullYear() !== heute.getFullYear() && { year: 'numeric' }),
  }).format(d)
  return t.uhrzeit ? `${datum} · ${t.uhrzeit.substring(0, 5)}` : datum
}

/** Tage bis zum Termin, bezogen auf das lokale Datum [heute] (YYYY-MM-DD) */
export function tageBis(datum: string, heute: string): number {
  return Math.round((Date.parse(`${datum}T00:00:00Z`) - Date.parse(`${heute}T00:00:00Z`)) / 86_400_000)
}

export function abstand(datum: string, heute: string): string {
  const tage = tageBis(datum, heute)
  if (tage === 0) return 'heute'
  if (tage === 1) return 'morgen'
  if (tage === -1) return 'gestern'
  return tage > 0 ? `in ${tage} Tagen` : `vor ${-tage} Tagen`
}

type Vergangen = { art: 'termin'; termin: Termin; zeit: number } | { art: 'erinnerung'; erinnerung: Erinnerung; zeit: number }

/** Vergangene Termine und abgehakte Erinnerungen in einer Liste, die jüngsten zuerst */
export function vergangeneEintraege(termine: Termin[], erinnerungen: Erinnerung[]): Vergangen[] {
  const alle: Vergangen[] = [
    ...termine.map((termin) => ({ art: 'termin' as const, termin, zeit: new Date(termin.beginn).getTime() })),
    ...erinnerungen.map((erinnerung) => ({ art: 'erinnerung' as const, erinnerung, zeit: new Date(erinnerung.faelligAm).getTime() })),
  ]
  return alle.sort((a, b) => b.zeit - a.zeit)
}
